// extracted by mini-css-extract-plugin
export default {"page":"QY-z","cartModal":"RY-z","checkout":"SY-z","placeholder":"TY-z","account":"UY-z"};